import { get, patchBlob } from "./restApi";

export const getReport = (payload) => {
    return get("assetMaintenanceCostReport/get-report", { ...payload });
};
export const getAssetBreakdownCostReport = (payload) => {
    return get("assetMaintenanceCostReport/get-asset-breakdown-cost-report", { ...payload });
};
export const getAssetCalibrationCostReport = (payload) => {
    return get("assetMaintenanceCostReport/get-asset-calibration-cost-report", { ...payload });
};
export const getReportTotalCostByContract = (payload) => {
    return get("assetMaintenanceCostReport/get-report-total-cost-by-contract", { ...payload });
};
export const getReportExcel = (payload) => {
    return patchBlob("assetMaintenanceCostReport/get-report-excel", { ...payload });
};
export const getAssetBreakdownCostReportExcel = (payload) => {
    return patchBlob("assetMaintenanceCostReport/get-asset-breakdown-cost-report-excel", { ...payload });
};
export const getAssetCalibrationCostReportExcel = (payload) => {
    return patchBlob("assetMaintenanceCostReport/get-asset-calibration-cost-report-excel", { ...payload });
};
export const getReportTotalCostByContractExcel = (payload) => {
    return patchBlob("assetMaintenanceCostReport/get-report-total-cost-by-contract-excel", { ...payload });
};